import OperationsController from "../adapters/user.controller";

const deleteUser = async(id) => {
    const response = await OperationsController.deleteUser(id);
    return response;
}

export default deleteUser;